module.exports = __webpack_public_path__ + "static/media/LINK-FTM.36dd1379.png";